import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_incoming_einvoice_unmatched_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  peppol_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  supplier_id_no: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_incoming_einvoice_unmatched_history_RowClass
  implements bl_fi_incoming_einvoice_unmatched_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    peppol_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    supplier_id_no: fromDatatype.VarcharDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
